<template>
  <div class="mx-3 pt-5 bg-blue-50">
    <b-row align-h="center">
      <b-col cols="11" class="font-responsive">
        <p class="h2 font-weight-bold font-italic text-center mb-5 mb-lg-3" v-orphans>
          {{ $t('home.bottomSection.howWeHelpHeader') }}
        </p>
      </b-col>
      <b-col cols="7" lg="6" class="text-center">
        <b-img
          fluid
          class="mx-lg-5 p-lg-5"
          :src="howWeHelpImage"
          alt="Akademia Przyszłości - Jak Pomagamy"
        ></b-img>
      </b-col>
      <b-col cols="11" lg="5" class="mx-5 py-5 px-0">
        <b-row class="how-we-help__carousel flex-nowrap">
          <b-col cols="auto" class="user-select-none mt-4">
            <b-icon-arrow-left-short
              @click="prevItem"
              class="border rounded-circle border-blue-500"
              font-scale="2"
            />
          </b-col>
          <b-col class="flex-grow-1">
            <div class="mx-auto">
              <div class="justify-content-center justify-content-lg-start">
                <div v-for="(item, index) in howWeHelp" :key="index" class="d-inline">
                  <b-icon-circle-fill
                    :variant="iconState(index)"
                    font-scale="1"
                    @click="itemId = index"
                    class="mr-3"
                  />
                </div>
              </div>
              <div class="mt-3 font-responsive">
                <Transition name="fade-short" mode="out-in">
                  <div :key="itemId">
                    <div class="font-weight-bold" v-orphans>{{ howWeHelp[itemId].title }}</div>
                    <p v-orphans>{{ howWeHelp[itemId].description }}</p>
                  </div>
                </Transition>
              </div>
            </div>
          </b-col>
          <b-col cols="auto" class="user-select-none mt-4">
            <b-icon-arrow-right-short
              @click="nextItem"
              class="border rounded-circle border-blue-500"
              font-scale="2"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import type { PL } from '@/types'

const { tm } = useI18n<{ message: PL }>()

const itemId = ref<number>(0)

const howWeHelp = tm('home.bottomSection.howWeHelp')

const howWeHelpImage = new URL(
  '/src/assets/images/akademia_przyszlosci_jak_pomagamy.png',
  import.meta.url
).href

const iconState = (index: number): string => (itemId.value === index ? 'blue-500' : 'blue-100')

const nextItem = (): void => {
  itemId.value = itemId.value === Object.keys(howWeHelp).length - 1 ? 0 : itemId.value + 1
}
const prevItem = (): void => {
  itemId.value = itemId.value === 0 ? Object.keys(howWeHelp).length - 1 : itemId.value - 1
}
</script>

<style lang="scss">
.how-we-help {
  &__carousel.row {
    margin-top: 30px;

    @media screen and (width >= 1170px) {
      margin-top: 150px;
    }
  }
}
</style>
